<div class="modal-header">
    <h4 class="modal-title" id="mondalAddCampaignTitle">Imágenes subidas: </h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<mat-dialog-content>
    <div class="modal-body">
        <div>
            <div class="row g-2">
                <div class="col mb-0">
                    <div class="table-responsive text-nowrap">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Imágen</th>
                                    <th>Fecha de Registro</th>
                                    <th>Eliminar</th>
                                </tr>
                            </thead>
                            <tbody class="table-border-bottom-0">
                                <tr *ngFor="let image of dataImages">
                                    <td>{{ image.id }}</td>
                                    <td><a href="{{ image.file }}" target="_blank">{{ image.nombre }}</a></td>
                                    <td>{{ image.created_at | date : "dd/MM/yyyy hh:mma": "-0000" }}</td>
                                    <td>
                                        <button mat-button color="warn" (click)="deleteImage(image.id)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
